var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 4.5C14.1156 4.5 13.5 3.88439 13.5 3.125C13.5 2.36561 14.1156 1.75 14.875 1.75C15.6344 1.75 16.25 2.36561 16.25 3.125C16.25 3.88439 15.6344 4.5 14.875 4.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9.5C1.5 11.2157 1.59389 12.492 1.80806 13.4557C2.01845 14.4024 2.32443 14.9529 2.68575 15.3142C3.04707 15.6756 3.59763 15.9816 4.54428 16.1919C5.50796 16.4061 6.7843 16.5 8.5 16.5C10.2157 16.5 11.492 16.4061 12.4557 16.1919C13.4024 15.9816 13.9529 15.6756 14.3142 15.3142C14.6756 14.9529 14.9816 14.4024 15.1919 13.4557C15.4061 12.492 15.5 11.2157 15.5 9.5C15.5 7.7843 15.4061 6.50796 15.1919 5.54428C15.168 5.43664 15.1429 5.33412 15.1165 5.23642C15.6547 5.17554 16.1319 4.91363 16.4714 4.5276C16.8613 5.75151 17 7.3715 17 9.5C17 16.4998 15.4997 18 8.5 18C1.50025 18 0 16.4998 0 9.5C0 2.50025 1.50025 1 8.5 1C10.6285 1 12.2485 1.13872 13.4724 1.52862C13.0864 1.86806 12.8245 2.34531 12.7636 2.88347C12.6659 2.85714 12.5634 2.83198 12.4557 2.80806C11.492 2.59389 10.2157 2.5 8.5 2.5C6.7843 2.5 5.50796 2.59389 4.54428 2.80806C3.59763 3.01845 3.04707 3.32443 2.68575 3.68575C2.32443 4.04708 2.01845 4.59763 1.80806 5.54428C1.59389 6.50796 1.5 7.7843 1.5 9.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 10.9165C4.25 10.9165 6.21158 5.95817 8.50002 9.49984C10.7885 13.0415 12.75 8.08317 12.75 8.08317",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ce4f04c1609a8779c07e39a20792a15c.svg";
export { ForwardRef as ReactComponent };